export default __webpack_public_path__ + "static/Screen Shot 2021-12-01 at 20.06.00-b86f74037834c832b88da9db0b80da36.png";